import { Controller } from "stimulus"

export default class extends Controller
  @targets: ["codeField", "clipboardButton"]
  
  @values =
    bgColor: String
    code: String
    linkColor: String

  connect: ->
    @update()

  handleBgColorChange: (event) ->
    @bgColorValue = event.target.value
    @update()

  handleLinkColorChange: (event) ->
    @linkColorValue = event.target.value
    @update()

  update: ->
    generatedCode = @codeValue
      .replace(/SUBSTITUTE_LINK_COLOR/, @linkColorValue || '')
      .replace(/SUBSTITUTE_BG_COLOR/, @bgColorValue || '')

    @codeFieldTarget.innerHTML = generatedCode

    @clipboardButtonTarget.dataset['clipboardText'] = generatedCode